import "./suppressConsole";

import React from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";

import { initI18n } from "js/i18n";
import { getInitialLocale } from "js/i18n/locale";

//
// entry point
//

// workaround for "failed to render" bug that is caused by out of date signed urls that won't reload
let usingBackForwardCache = false;
try {
    usingBackForwardCache = window.performance.getEntriesByType("navigation")[0].type === "back_forward";
} catch (err) {
    // quietly ignore
}
if (document.wasDiscarded || usingBackForwardCache) {
    window.location.reload();
}

const root = document.createElement("div");
root.id = "react-root";
root.style.display = "contents";
document.body.appendChild(root);
const rootNode = createRoot(root);

// Have to do that because on Firefox document.fonts.keys() is not properly iterable
function safeIterableToArray(iterable) {
    const results = [];

    while (true) {
        const { done, value } = iterable.next();
        if (done) break;
        results.push(value);
    }

    return results;
}

(async () => {
    const { init } = await import(/* webpackMode: "eager" */ "js/firebase/init");
    await init();

    // `getInitialLocale()` can emit analytics events, which can touch Firebase auth.
    // Ensure Firebase is initialized before running locale detection / i18n init.
    const i18nInstance = initI18n(getInitialLocale());

    const muiFonts = safeIterableToArray(document.fonts.keys()).filter(font => font.family.includes("Material"));
    await Promise.all(muiFonts.map(font => font.load()));

    const { Entrypoint } = await import(/* webpackMode: "eager" */ "./Entrypoint");
    rootNode.render(
        <I18nextProvider i18n={i18nInstance}>
            <Entrypoint />
        </I18nextProvider>,
    );
})();
